import { render, staticRenderFns } from "./closed-cases.vue?vue&type=template&id=41cf7772&"
import script from "./closed-cases.vue?vue&type=script&lang=js&"
export * from "./closed-cases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports